/**
 * Departure Date Manager - Frontend JavaScript
 *
 * Main entry point for frontend functionality.
 * This file imports all necessary modules for departure date filtering.
 */

// Import CSS
import '../css/frontend.scss';

import AppInitializer from './initializer/app-initializer.js';

// Initialize the application
new AppInitializer();
